"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNormalizedMergedState = getNormalizedMergedState;
exports["default"] = void 0;

var _getMergedData = _interopRequireDefault(require("./getMergedData"));

var _getUnifiedData = _interopRequireDefault(require("./getUnifiedData"));

var _normalize2 = _interopRequireDefault(require("./normalize"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getNormalizedMergedState(state, patch) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isMergingArray = typeof config.isMergingArray === 'undefined' ? true : config.isMergingArray;
  var nextState = config.nextState || {};
  if (!patch) return nextState;
  Object.keys(patch).forEach(function (patchKey) {
    var data = patch[patchKey];
    if (!data) return;
    var nextData = (0, _getUnifiedData["default"])(data, config);

    function doWithNormalizedPatch(normalizedPatch, normalizerConfig) {
      var subNormalizedMergedState = getNormalizedMergedState(state, normalizedPatch, _objectSpread({
        nextState: nextState
      }, normalizerConfig));
      Object.assign(nextState, subNormalizedMergedState);
    }

    (0, _normalize2["default"])(_defineProperty({}, patchKey, nextData), _objectSpread({
      doWithNormalizedPatch: doWithNormalizedPatch
    }, config));

    if (isMergingArray) {
      var previousData = state[patchKey];
      nextData = (0, _getMergedData["default"])(nextData, previousData, config);
    }

    nextState[patchKey] = (0, _getMergedData["default"])(nextData, nextState[patchKey], config);
  });
  return nextState;
}

var _default = getNormalizedMergedState;
exports["default"] = _default;